import { Audit, AuditEventEnum, IActivityLayout, useAuditsEvents } from '@diana/core';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { THING_PAGE_NS } from '../../../../i18n';
import { IThingActivityProps } from './ThingActivities.types';
import { ThingDataChangeDetails } from './ThingDataChangeDetails';

export const ThingActivity = ({ audit, thing, keyword }: IThingActivityProps) => {
  const { createTextSummaryLayout, createUpdateDataLayout } = useAuditsEvents();
  const { t } = useTranslation(THING_PAGE_NS);

  const { verb, object, details } = useMemo((): IActivityLayout => {
    switch (audit.activity.type) {
      case AuditEventEnum.CREATED:
        return createTextSummaryLayout({
          audit,
          verb: t('activity.verbs.created'),
          data: audit.activity.taskName ?? '',
        });

      case AuditEventEnum.EDITED:
        return createUpdateDataLayout({
          audit,
          verb: t('activity.verbs.edited'),
          data: [],
          detailsComponent: (
            <ThingDataChangeDetails keyword={keyword} thing={thing} audit={audit} />
          ),
        });

      default:
        return createTextSummaryLayout({ audit, verb: '[unknown event]' });
    }
  }, [audit, createTextSummaryLayout, t, createUpdateDataLayout, keyword, thing]);

  return <Audit audit={audit} details={details} verb={verb} object={object} />;
};
